import API from "./apiConfig"

export const getOrganization = () => {
  return API
    .get('/organizations.json')
    .then(res => res.data)
}
